import { render } from "./StoreListPage.vue?vue&type=template&id=537ea05e&scoped=true"
import script from "./StoreListPage.vue?vue&type=script&lang=js"
export * from "./StoreListPage.vue?vue&type=script&lang=js"

import "./StoreListPage.vue?vue&type=style&index=0&id=537ea05e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537ea05e"]])

export default __exports__